export const GET_VIDEO_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    videoblock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      heading
      url
      videoTitle
      text
      linkText
      externalLink
      useButtonLink
      backgroundColor
      audienceCollection{
        items{
            __typename
            sys{id}
            audianceId
          }
      }
      linkToPage {
        content {
          __typename
        }
        slug
      }
      isColumn
      isReverse
    }
  }
`;
